import { useMemo } from 'react';
import { TCollections } from 'types';
import { MediaSlide } from 'components';
import { TPostMedia } from 'types';

type Props = {
  avatar?: string | File;
  collections?: TCollections[];
  rank?: number;
};

function CollectionsImage({ avatar = '', collections = [], rank }: Props) {
  const listCollection = useMemo(() => {
    return [{ id: 0, url: avatar }, ...collections];
  }, [avatar, collections]);

  return (
    <div className="w-full relative">
      <MediaSlide
        data={
          listCollection.map((item) => {
            return {
              ...item,
              type: `image/${(item?.url as string)?.split('.').pop()}`,
            };
          }) as TPostMedia[]
        }
        showThumbs={true}
        rank={rank}
      />
    </div>
  );
}

export default CollectionsImage;
